import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import Logout from '@mui/icons-material/Logout';

import { removeSessionStorage } from '../../utils/sessionStorageHandler';
import {
	permission,
	sessionStorageKeyAuthorizationToken,
	sessionStorageKeyIsRedirectedToG500Lite,
	sessionStorageKeyTokenIssuedDatetime,
} from '../../const/commonConst';
import { UserInfoType } from '../../type/UserInfoType';
import { deleteSessionInfoHandler } from '../../handler/deleteSessionInfoHandler';

import theme from '../../../theme';

const initUserInfo = {
	isLogin: false,
	companyName: '',
	userName: '',
	permission: permission.id.unknown,
};

type LogoutButtonPropsType = {
	setUserInfo: React.Dispatch<React.SetStateAction<UserInfoType>>;
};

/**
 * ログアウトボタン
 */
const LogoutButton = (props: LogoutButtonPropsType) => {
	const navigate = useNavigate();

	const logout = async () => {
		await deleteSessionInfoHandler();

		removeSessionStorage(sessionStorageKeyAuthorizationToken);
		removeSessionStorage(sessionStorageKeyTokenIssuedDatetime);
		removeSessionStorage(sessionStorageKeyIsRedirectedToG500Lite);
		props.setUserInfo(initUserInfo);
		navigate('/login');
	};

	return (
		<IconButton
			id="logoutButton"
			onClick={logout}
			sx={{
				color: theme.palette.common.white,
				marginRight: 2,
			}}
		>
			<Logout />
		</IconButton>
	);
};

export default memo(LogoutButton);
